import EmpleadosListPage from '@/modules/rrhh/empleados/pages/EmpleadosListPage.jsx';
import EmpleadoFormPage from '@/modules/rrhh/empleados/pages/EmpleadoFormPage.jsx';
import ListadoAsistencias from '@/pages/RRHH/Asistencias/ListadoAsistencias.jsx';
import FormAsistencia from '@/pages/RRHH/Asistencias/FormAsistencia.jsx';
import ListadoTurnos from '@/pages/RRHH/Turnos/ListadoTurnos.jsx';
import FormTurno from '@/pages/RRHH/Turnos/FormTurno.jsx';
import FormAsignacionTurno from '@/pages/RRHH/Turnos/FormAsignacionTurno.jsx';
import ListadoVacaciones from '@/pages/RRHH/Vacaciones/ListadoVacaciones.jsx';
import FormVacacion from '@/pages/RRHH/Vacaciones/FormVacacion.jsx';

export const rrhhRoutes = [
  {
    path: '/rrhh/empleados',
    component: EmpleadosListPage,
  },
  {
    path: '/rrhh/empleados/nuevo',
    component: EmpleadoFormPage,
  },
  {
    path: '/rrhh/empleados/:id/editar',
    component: EmpleadoFormPage,
  },
  {
    path: '/rrhh/asistencias',
    component: ListadoAsistencias,
  },
  {
    path: '/rrhh/asistencias/nueva',
    component: FormAsistencia,
  },
  {
    path: '/rrhh/asistencias/:id/editar',
    component: FormAsistencia,
  },
  {
    path: '/rrhh/turnos',
    component: ListadoTurnos,
  },
  {
    path: '/rrhh/turnos/nuevo',
    component: FormTurno,
  },
  {
    path: '/rrhh/turnos/:id/editar',
    component: FormTurno,
  },
  {
    path: '/rrhh/turnos/asignaciones/nueva',
    component: FormAsignacionTurno,
  },
  {
    path: '/rrhh/turnos/asignaciones/:id/editar',
    component: FormAsignacionTurno,
  },
  {
    path: '/rrhh/vacaciones',
    component: ListadoVacaciones,
  },
  {
    path: '/rrhh/vacaciones/nueva',
    component: FormVacacion,
  },
  {
    path: '/rrhh/vacaciones/:id/editar',
    component: FormVacacion,
  },
];

export default rrhhRoutes;
